import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Skeleton,
  Tbody,
  Box,
  Heading,
} from "@chakra-ui/react";
import { getOrderStatusBadge } from "../../Utils/utils";
import { useHistory, useParams } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import moment from "moment";
import TdType from "../Common/Table/TdType";
import { numberFormatter } from "../../Utils/formatUtils";
import CustomTBody from "../Common/Table/CustomTBody";
import useFetch from "../../hooks/useFetch";

const OrdersTable = () => {
  const history = useHistory();
  moment.locale();
  let params = useParams().state;
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { get } = useFetch();

  useEffect(() => {
    get("/orders?statusId=2,3")
      .then(async (res) => {
        setOrders(res.orders);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const createRows = () => {
    let formattedRows = orders.map((order) => {
      return [
        {
          item: <TdType text={order.id} />,
        },
        {
          item: (
            <TdType text={order.businessName + " (" + order.userId + ")"} />
          ),
        },
        {
          item: <TdType text={getOrderStatusBadge(order)} />,
        },
        {
          item: (
            <TdType
              text={
                order.confirmedAt
                  ? moment(order.confirmedAt).format("DD-MM-YYYY HH:mm:ss")
                  : "-"
              }
              title={
                order.confirmedAt
                  ? moment(order.confirmedAt).format("DD-MM-YYYY HH:mm:ss")
                  : "-"
              }
            />
          ),
        },
        {
          item: (
            <TdType
              text={moment(order.statusUpdatedAt).format("DD-MM-YYYY HH:mm:ss")}
              title={moment(order.statusUpdatedAt).format(
                "DD-MM-YYYY HH:mm:ss"
              )}
            />
          ),
        },
        {
          item: <TdType text={numberFormatter(order.total)} />,
        },
        {
          item: (
            <TdType
              inputType="icon"
              onClick={() =>
                history.push(`/pedidos/${order.id}`, {
                  prevPath: params,
                })
              }
              icon={FaRegEdit}
              title="Ver pedido"
            />
          ),
        },
      ];
    });
    return formattedRows;
  };

  const createSkeleton = () => {
    let skeleton = [];
    for (let index = 0; index < 7; index++) {
      skeleton.push({ item: <Skeleton height="1rem" /> });
    }
    return skeleton;
  };

  return (
    <Box overflowX={"scroll"} pb={"0.5rem"}>
      <Heading variant="h1" mb="1rem">
        Últimos pedidos
      </Heading>
      <Table variant="striped" colorScheme="gray" fontSize="0.8em">
        <Thead>
          <Tr>
            <Th fontSize="0.8em">#</Th>
            <Th fontSize="0.8em">Cliente</Th>
            <Th fontSize="0.8em">Estado </Th>
            <Th fontSize="0.8em">Confirmación </Th>
            <Th fontSize="0.8em">Últ. estado </Th>
            <Th fontSize="0.8em">Total ($)</Th>
            <Th fontSize="0.8em" textAlign="center">
              Ver pedido
            </Th>
          </Tr>
        </Thead>
        {isLoading ? (
          <CustomTBody rows={[createSkeleton()]} />
        ) : orders.length ? (
          <CustomTBody rows={createRows()} />
        ) : (
          <Tbody>
            <Tr>
              <Td colSpan="100%">
                <Box padding="1rem 0">No se encontraron resultados</Box>
              </Td>
            </Tr>
          </Tbody>
        )}
      </Table>
    </Box>
  );
};

export default OrdersTable;
